<template>
   <div>
      <div v-if="isLoading" class="loading" />
      <notification-modal :data="notification" />
      <keep-alive :include="cachedComponents">
         <router-view />
      </keep-alive>
      <ChatbotButton type-btn="FAQ" class="faq-chatbot" />
      <ChatbotButton type-btn="CHAT_AI" class="ai-chatbot" />
   </div>
</template>
<script>
import NotificationModal from '@/components/modal/NotificationModal'
import '@/assets/css/custom.css'
import '@/assets/css/override.scss'
import { bus } from '@/main.js'
import ChatbotButton from '@/modules/mobile/components/chatbot/ChatbotButton.vue'

export default {
   components: {
      NotificationModal,
      ChatbotButton
   },
   data() {
      return {
         cachedComponents: []
      }
   },
   computed: {
      isLoading() {
         return this.$store.state.isLoading
      },
      notification() {
         return this.$store.state.notification
      }
   },
   created() {
      // Event to remove the components from the cache
      bus.$on('addCachedComponents', (data) => {
         this.cachedComponents.push(data)
      })

      bus.$on('clearCachedComponents', (data) => {
         // If the received component exist
         if (this.cachedComponents?.includes(data)) {
            // Get the index of the component in the array
            const index = this.cachedComponents.indexOf(data)
            // Remove it from the array
            this.cachedComponents.splice(index, 1)
         }
      })
   }
}
</script>

<style >
.faq-chatbot .chatbot-trigger {
  bottom: 110px !important;

}

.ai-chatbot .chatbot-trigger {
   bottom:51px !important;
   z-index: 10000;

}

.ai-chatbot .chatbot-container {
  bottom: 82px !important;
  z-index: 9999;
}
</style>
